import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpdateDateFilterWithTimezonesNotification = ({
  onUpdateClick,
  useUTC
}) => {
  return /*#__PURE__*/_jsxs(Alert, {
    "data-test-id": "fr-update-filter-notification",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.dateFilterWithTimezones.title"
    }),
    type: "tip",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.dateFilterWithTimezones.text"
      }), !useUTC && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        marginBlockStart: "250",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.dateFilterWithTimezones.warning"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "fr-update-date-filter-button",
        use: "transparent",
        onClick: onUpdateClick,
        responsive: false,
        paddingInlineStart: "0",
        paddingBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.dateFilterWithTimezones.update"
        })
      })
    })]
  });
};
export default UpdateDateFilterWithTimezonesNotification;